import React from "react";
import styled from "styled-components";
import { words } from "./translations";

const ThankYou = ({ language, responses }) => {
    return (
        <Container>
            <ContentWrapper>
                <ThankYouCard>
                    <SuccessIcon>✅</SuccessIcon>
                    
                    <Title>We've entered your submission</Title>
                    
                    <Message>
                        Thank you for your response
                    </Message>
                </ThankYouCard>
            </ContentWrapper>
        </Container>
    );
};

export default ThankYou;

const Container = styled.div`
    width: 100%;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    box-sizing: border-box;
`;

const ContentWrapper = styled.div`
    width: 100%;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const ThankYouCard = styled.div`
    width: 100%;
    background: #ffffff;
    border-radius: 16px;
    padding: 48px;
    text-align: center;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    
    @media (max-width: 768px) {
        padding: 32px 24px;
    }
`;

const SuccessIcon = styled.div`
    font-size: 64px;
    margin-bottom: 24px;
    
    @media (max-width: 768px) {
        font-size: 48px;
        margin-bottom: 20px;
    }
`;

const Title = styled.h1`
    font-size: 36px;
    color: #2D3748;
    margin-bottom: 20px;
    font-family: 'Raleway';
    font-weight: 700;
    
    @media (max-width: 768px) {
        font-size: 28px;
        margin-bottom: 16px;
    }
`;

const Message = styled.p`
    font-size: 18px;
    color: #4A5568;
    line-height: 1.6;
    font-family: 'Raleway';
    
    @media (max-width: 768px) {
        font-size: 16px;
    }
`; 